/*
 * Copyright (c) Nexign, JSC, 2020-2021.
 */
/**
 * Lazy loading of the component PageAccountInfo
 *
 * @author Aleksandr Perkhunov
 * @version 1.11.0
 * @since 1.10.0
 */
import loadable from '../../utils/loadable';

export default loadable(() => import(/* webpackChunkName: "PageAccountInfoRoute" */ './PageAccountInfoRoute'), undefined);
